module.exports = __webpack_public_path__ + "img/courses7.69d17471.jpg";